import React from "react";
import { useHistory } from "react-router-dom";

const AppDevicesRow = ({
  item,
  currentDay,
  handleDelete,
  handleAppSelect,
  getLangTranslation,
  handleStatusChange,
}) => {
  //   console.log(item);
  const history = useHistory();
  function getCategoryStatus(item) {
    if (item?.status === 0) {
      return [
        "text-success border-success icon-check-fill",
        "text-blue-50 icon-ban",
        "text-blue-50 icon-info-triangle-fill",
      ];
    } else if (item?.status === 1) {
      return [
        "text-blue-50 icon-check-fill",
        "text-blue-50 icon-info-triangle-fill",
        "text-danger border-danger icon-ban",
      ];
    } else if (item?.status === 2) {
      return [
        "text-blue-50 icon-check-fill",
        "text-warning border-warning icon-info-triangle-fill",
        "text-blue-50 icon-ban",
      ];
    } else {
      return ["text-blue-50", "text-blue-50", "text-blue-50"];
    }
  }

  return (
    <tr>
      <td className="v-middle">
        <div className="form-check">
          {/*!item?.systemApp == 1 && (
            <input
              className="form-check-input"
              type="checkbox"
              id={item?.appUuid}
              name={item?.appUuid}
              checked={item?.isChecked || 0}
              onChange={handleAppSelect}
            />
          )*/}
          <label
            className="form-check-label d-inline-flex align-items-center"
            htmlFor={item?.appUuid}
          >
            <span className="icon-wrap rounded-3 icon-sm me-2 p-0 overflow-hidden">
              <img src={item?.image} alt="avatar" />
            </span>
            {item?.app_name}
          </label>
        </div>
      </td>
      <td className="v-middle text-nowrap">{item?.category}</td>
      <td className="v-middle text-nowrap">
        <div className="bordered-list-text gap-2 d-flex flex-column">
          {item?.allowedTimeSlot[currentDay]?.map((time) => {
            return (
              <div className="bordered-list-text-inner d-inline-flex gap-6 align-items-center">
                <span className="bg-blue-50 text-blue-900 text-small p-1 border rounded-1">
                  11 : 00 - 14 : 00
                </span>
                <i className="icon-remove fs-5 text-blue-600 pt-cursor" />
              </div>
            );
          })}
        </div>
      </td>
      <td className="v-middle text-nowrap">
        <div className="d-inline-flex align-items-center gap-3">
          <div className="d-inline-flex align-items-center gap-6">
            {getCategoryStatus(item)?.map((icon, index) => {
              return (
                <i
                  className={`fs-5 border rounded-circle ${icon}`}
                  key={index}
                />
              );
            })}
          </div>
        </div>
      </td>
      <td className="v-middle text-nowrap text-end">
        <div className="d-inline-flex align-items-center gap-3 me-2">
          <i
            className={`icon-trash fs-4 pt-cursor text-blue-700 ${
              item?.systemApp == 1 ? "disable-class" : ""
            }`}
            onClick={() => {
              if (!item?.systemApp == 1) handleDelete(item);
            }}
          />

          <div className="dropdown">
            <i
              className="icon-three-dots fs-2 pt-cursor text-gray"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            />
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li
                className="px-6 pt-cursor fw-semibold d-flex justify-content-between align-items-center gap-1"
                onClick={() => handleStatusChange(item, item?.appUuid, "ALLOW")}
              >
                {getLangTranslation("ALLOW", "ALLOW")}{" "}
              </li>
              <li
                className="px-6 pt-cursor fw-semibold d-flex justify-content-between align-items-center gap-1"
                onClick={() => handleStatusChange(item, item?.appUuid, "BLOCK")}
              >
                {getLangTranslation("BLOCK", "BLOCK")}{" "}
              </li>
              <li
                className="px-6 pt-cursor fw-semibold d-flex justify-content-between align-items-center gap-1"
                onClick={() => handleStatusChange(item, item?.appUuid, "WARN")}
              >
                {getLangTranslation("WARN", "WARN")}{" "}
              </li>

              <li
                className="px-6 pt-cursor fw-semibold d-flex justify-content-between align-items-center gap-1"
                onClick={() => history.push("/set-daily-limit")}
              >
                {getLangTranslation(
                  "HOW_TO_SET_RULES_TIME_SUPERVISION_SET_DAILY_LIMIT",
                  "Set daily limit"
                )}{" "}
                <i className="icon-arrow-right" />
              </li>
              <li
                className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1"
                onClick={() => history.push("/set-rules/set-schedule")}
              >
                {getLangTranslation(
                  "TIME_SUPERVISION_SET_A_SCHEDULE",
                  "Set a schedule"
                )}{" "}
                <i className="icon-arrow-right" />
              </li>
              <li
                className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1"
                onClick={() => handleStatusChange(item, item?.appUuid, "ALERT")}
              >
                {!item?.enableNotificationWhenUsed
                  ? getLangTranslation(
                      "APP_WEB_CATEGORY_WARN_APP_WHEN_USED",
                      "Alert me when used"
                    )
                  : getLangTranslation(
                      "APP_WEB_CATEGORY_DO_NOT_WARN_APP_WHEN_USED",
                      "Remove warning"
                    )}{" "}
              </li>
            </ul>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default AppDevicesRow;
